import { useState } from 'react';
import HardwareTestService from '../../services/hardware/HardwareTestService';
import useAlerts from '../useAlerts';
import useLoading from '../useLoading';

const useHardwareTest = () => {
  const { show: showAlert } = useAlerts();
  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  const [isTesting, setIsTesting] = useState(false);

  const testPrinter = async (branchId: number) => {
    try {
      setIsTesting(true);
      showLoadingIndicator();

      await HardwareTestService.testPrinter({ branchId }); // ✅ Enviar objeto
      showAlert('success', 'Prueba de Impresora', 'Se imprimió la hoja de prueba correctamente.');
    } catch (error) {
      showAlert('error', 'Error de Impresora', 'No se pudo imprimir la hoja de prueba.');
    } finally {
      hideLoadingIndicator();
      setIsTesting(false);
    }
  };

  const testCashDrawer = async (branchId: number) => {
    try {
      setIsTesting(true);
      showLoadingIndicator();

      await HardwareTestService.testCashDrawer({ branchId }); // ✅ Enviar objeto
      showAlert('success', 'Prueba de Cajón', 'Se abrió el cajón de dinero correctamente.');
    } catch (error) {
      showAlert('error', 'Error de Cajón', 'No se pudo abrir el cajón de dinero.');
    } finally {
      hideLoadingIndicator();
      setIsTesting(false);
    }
  };

  return {
    isTesting,
    testPrinter,
    testCashDrawer,
  };
};

export default useHardwareTest;
